import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "No matching data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_ctx.filteredItems.length > 0)
    ? (_openBlock(), _createBlock(_component_VueMultiselect, _mergeProps({
        key: 0,
        modelValue: _ctx.selectedItems,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems) = $event)),
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        "close-on-select": false,
        searchable: true,
        options: _ctx.computedOptions,
        onRemove: _ctx.handleRemove,
        multiple: true,
        "hide-selected": true,
        "track-by": "value",
        label: "label",
        limit: 9999,
        "limit-text": _ctx.limitText,
        "select-label": '',
        "deselect-label": '',
        "open-direction": "bottom"
      }, _ctx.$attrs, { ref: "multiselect" }), {
        option: _withCtx(({ option }) => [
          (option.value === '-1' && !_ctx.isAllSelected)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.selectAll), 1))
            : (option.value === 'remove_all')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.removeAll), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(option.label), 1))
        ]),
        noResult: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 16, ["modelValue", "options", "onRemove", "limit-text"]))
    : _createCommentVNode("", true)
}